import { HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type QualityControlPredictor from "./QualityControlPredictor";
import type Version from "./Version";

@Model()
class QualityControlTrigger extends ApplicationRecord {
  static jsonapiType = "quality_control_trigger";

  @HasMany() qualityControlPredictors: QualityControlPredictor[];

  @HasMany() versions: Version[];
}

export default QualityControlTrigger;
